import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import loader from '../../assets/img/noConnection.png';

const Internet = (props) => (
  <Modal isOpen={props.isOpen} centered={true}>
    <ModalBody>
      <div style={{textAlign: 'center'}}>
        <img src={loader} />
        <br/>
        <h3 style={{color: 'blue',fontWeight: 'bold'}}>Ooops!</h3>
        <h5>Slow or No Internet Connection.</h5>
        <h5>Please check your internet settings</h5>
      </div>
    </ModalBody>
  </Modal>
);

export default Internet;



// WEBPACK FOOTER //
// ./src/components/Internet/Internet.js